export default __webpack_public_path__ + "static/media/icon-caret.c2d6fb16.svg";